"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CheckViewport = /** @class */ (function () {
    function CheckViewport() {
    }
    CheckViewport.checkIfInViewport = function (el) {
        var rect = el.getBoundingClientRect();
        return (rect.top <= ((window.innerHeight || document.documentElement.clientHeight) / 4 * 3) && rect.top >= 0);
    };
    return CheckViewport;
}());
exports.default = CheckViewport;
